import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postuser, getAllUser } from "../redux/actions/index.js";
import Swal from "sweetalert2";

export default function Registro() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    nombre: "",
    tipo: "",
    dni: "",
  });
  const dispatch = useDispatch();
  const usuarios = useSelector((state) => state.usuarios);

  useEffect(() => {
    dispatch(getAllUser());
  }, [dispatch]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await dispatch(postuser(formData));

      if (response) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Perfil creado satisfactoriamente",
          showConfirmButton: false,
          timer: 1500,
        });
        dispatch(getAllUser());
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Registro fallido",
        });
      }
    } catch (error) {
      
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un problema al crear el usuario",
      });
    }
  };

  return (
    <div className="grid bg-backgroundClaro grid-cols-1 md:grid-cols-2 min-h-screen h-full w-full">
      <div className="bg-backgroundOscuro rounded-lg m-4 p-8">
        <h1 className="text-textoClaro text-4xl font-bold mb-6">
          Crear Usuario Nuevo
        </h1>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="text-textoClaro block mb-2">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>

            <div>
              <label htmlFor="dni" className="text-textoClaro block mb-2">
                DNI
              </label>
              <input
                id="dni"
                name="dni"
                type="text"
                className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
                value={formData.dni}
                onChange={handleInputChange}
                required
              />
            </div>

            <div>
              <label htmlFor="nombre" className="text-textoClaro block mb-2">
                Nombre
              </label>
              <input
                id="nombre"
                name="nombre"
                type="text"
                className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
                value={formData.nombre}
                onChange={handleInputChange}
                required
              />
            </div>

            <div>
              <label htmlFor="password" className="text-textoClaro block mb-2">
                Contraseña
              </label>
              <input
                id="password"
                name="password"
                type="password"
                className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
            </div>

            <div>
              <label htmlFor="tipo" className="text-textoClaro block mb-2">
                Tipo de Usuario
              </label>
              <select
                id="tipo"
                name="tipo"
                className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
                value={formData.tipo}
                onChange={handleInputChange}
              >
                <option value="">Seleccione un tipo de usuario</option>
                <option value="Super_Admin">Administrador</option>
                <option value="Operario">Operario</option>
              </select>
            </div>

            <button
              type="submit"
               className="bg-green-900 w-full flex items-center justify-center my-2 p-2 rounded-md text-textoClaro font-bold text-xl hover:bg-green-600 shadow-lg shadow-green-500/50"
            >
              Registrar
            </button>
          </div>
        </form>
      </div>

      <div className="bg-backgroundOscuro rounded-lg m-4 p-8">
        <h2 className="text-textoClaro text-4xl font-bold mb-4">Usuarios Registrados</h2>
        <ul className="flex flex-wrap gap-4">
          {usuarios && usuarios.length > 0 ? (
            usuarios.map((e) => (
              <li
                key={e.id}
                className="bg-backgroundClaro p-4 rounded-lg shadow-md w-full lg:w-[calc(50%-1rem)]"
              >
                
                  <h3 className="text-textoOscuro font-semibold">{e.nombre}</h3>
                  <p className="text-textoOscuro">{e.dni}</p>
                  <p className="text-textoOscuro">{e.rol}</p>
                  <p className="text-textoOscuro">{e.email}</p>
                
              </li>
            ))
          ) : (
            <p className="text-text-textoClaro">No hay usuarios registrados.</p>
          )}
        </ul>
      </div>
    </div>
  );
}
